import {
	primaryColor,
	warningColor,
	dangerColor,
	successColor,
	infoColor,
	roseColor,
	grayColor,
	cardTitle
} from "assets/jss/material-dashboard-pro-react.js";

const chartsStyle = {
	cardTitle,
	cardCategory: {
		margin: "0",
		color: grayColor[0]
	},
	cardIconTitle: {
		...cardTitle,
		marginTop: '15px',
		marginBottom: '0',
		marginRight: '48px',
		fontSize: '18px',
	},
	cardIconTitleDisabled: {
		color: '#aaa',
	},
	disableChartIcon: {
		'& > div': {
			background: '#aaa !important',
		},
	},
	legendTitle: {
		color: grayColor[0],
		margin: "10px 0 !important",
		display: "flex"
	},
	primary: {
		color: primaryColor[0]
	},
	warning: {
		color: warningColor[0]
	},
	danger: {
		color: dangerColor[0]
	},
	success: {
		color: successColor[0]
	},
	info: {
		color: infoColor[0]
	},
	rose: {
		color: roseColor[0]
	},
	gray: {
		color: grayColor[0]
	},
	cardFooter: {
		marginRight: '30px',
	},
	datePickerLabel: {
		fontSize: '11px',
		lineHeight: '21px',
		color: '#aaa',
	},
	downloadButton: {
		maxWidth: '130px',
		paddingLeft: '28px',
		paddingRight: '16px',
	},
	buttonIcon: {
		marginLeft: '10px',
	},
	loadingIndicator: {
		float: 'right',
		position: 'absolute',
		right: '0',
		top: '2px',
	},
	datetimeWrapper: {
		position: 'relative',
		'& .rdtPicker': {
			top: 'auto',
			bottom: '100%',
			cursor: 'pointer',

			'&:after': {
				display: 'none',
			},
			'&:before': {
				display: 'none',
			},
		},

		'& input.form-control': {
			fontSize: '14px',
			cursor: 'pointer',
			fontFamily: 'Roboto',
		},
	},
	datetimeWrapperDisabled: {
		'& .rdtPicker': {
			cursor: 'auto',
		},
		'& input.form-control': {
			cursor: 'auto',
		},
	},
	datetimeIcon: {
		padding: "0px",
		position: 'absolute',
		right: '0',
		bottom: '50%',
		transform: 'translateY(50%)',
		color: '#555',
	},
	emptyDataMessage: {
		fontSize: '18px',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		textAlign: 'center',
		justifyContent: 'center',
		color: '#555',
	},
	cardBody: {
		flex: 1,
		padding: '35px 0 0 0',
		overflow: 'hidden',
	},
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		height: '450px',
	},
	menuItem: {
		width: '130px',
		padding: '11px 25px',
	},
};

export default chartsStyle;
